import { Injectable } from '@angular/core';
import { SearchResourceType } from '@app/core/model/search/search-resource-type';
import { SearchResourceDictionaryService } from '@app/core/services/resource-dictionary/search-resource-dictionary.service';
import { SiteNavigationLinksService } from '@app/core/services/site-navigation/site-navigation-links.service';
import { BsshDatePipe } from '@app/core/utilities/pipes/bssh-date.pipe';
import { BytesPipe } from '@app/core/utilities/pipes/bytes.pipe';
import { StatusToDisplayName } from '@app/core/utilities/pipes/status-to-display-name.pipe';
import { SearchColumnFields, SearchGridOptionsFormatter } from '@app/search/gridOptions/search-grid-options-formatter';
import { BiosampleChooserGridOptionsFormatter } from './biosample-chooser-grid-options-formatter';
import { FileChooserGridOptionsFormatter } from './file-chooser-grid-options.formatter';
import { ProjectChooserGridOptionsFormatter } from './project-chooser-grid-options-formatter';
import { SampleChooserGridOptionsFormatter } from './sample-chooser-grid-options.formatter';
import { RunChooserGridOptionsFormatter } from './run-chooser-grid-options-formatter';
import { DatasetChooserGridOptionsFormatter } from './dataset-chooser-grid-options.formatter';
import { ResourceService } from '@app/core/services/toolbar/resource.service';
import { ResourceType } from '@app/core/model/resource-type';
import { RunsStore } from '@app/core/store/runs/runs.store';
import { HttpClient } from '@angular/common/http';
import { AppResultFileChooserGridOptionsFormatter } from './app-result-file-chooser-grid-options.formatter';
import { AppResultChooserGridOptionsFormatter } from './app-result-chooser-grid-options.formatter';

export interface IChooserGridOptionsFactoryService {
  getGridOptionsFormatterForResource(resourceType: SearchResourceType): SearchGridOptionsFormatter<SearchColumnFields>;
}

@Injectable({
  providedIn: 'root'
})
export class ChooserGridOptionsFactoryService implements IChooserGridOptionsFactoryService {

  constructor(
    private resourceDictionaryService: SearchResourceDictionaryService,
    private bytePipe: BytesPipe,
    private bsshDatePipe: BsshDatePipe,
    private siteNavigationLinksService: SiteNavigationLinksService,
    private resourceService: ResourceService,
    private http: HttpClient,
    private statusToDisplayName: StatusToDisplayName
  ) { }


  getGridOptionsFormatterForResource(resourceType: SearchResourceType): SearchGridOptionsFormatter<SearchColumnFields> {
    switch (resourceType) {
      case SearchResourceType.Project:
        return new ProjectChooserGridOptionsFormatter(this.resourceDictionaryService, this.bytePipe, this.bsshDatePipe);
      case SearchResourceType.Run:
        return new RunChooserGridOptionsFormatter(
          this.resourceDictionaryService, 
          this.bsshDatePipe,
          this.resourceService.getStoreForResourceType(ResourceType.RUNS) as RunsStore
        );
      case SearchResourceType.Biosample:
        return new BiosampleChooserGridOptionsFormatter(this.resourceDictionaryService, this.bsshDatePipe, this.http);
      case SearchResourceType.Sample:
        return new SampleChooserGridOptionsFormatter(this.resourceDictionaryService, this.bsshDatePipe, this.http);
      case SearchResourceType.File:
        return new FileChooserGridOptionsFormatter(this.resourceDictionaryService, this.bsshDatePipe, this.http);
      case SearchResourceType.AppResultFile:
        return new AppResultFileChooserGridOptionsFormatter(this.resourceDictionaryService, this.bsshDatePipe, this.siteNavigationLinksService, this.http);
      case SearchResourceType.Dataset:
        return new DatasetChooserGridOptionsFormatter(this.resourceDictionaryService, this.bsshDatePipe, this.bytePipe, this.http, this.statusToDisplayName);
      case SearchResourceType.AppResult:
        return new AppResultChooserGridOptionsFormatter(this.resourceDictionaryService, this.bsshDatePipe, this.siteNavigationLinksService, this.http);
      default:
        throw Error(`Chooser Grid Options for ${resourceType} not supported.`);
    }
  }
}
